module.exports = __webpack_public_path__ + "static/media/skull-cow.e8550078.svg";